<template>
  <modal
    ref="addPrice"
    :ok-disabled="loading"
    :ok-title="!edit ? 'Pridať' : 'Upraviť'"
    :title="!edit ? 'Nová hodnota' : 'Upraviť hodnotu'"
    cancel-title="Zrušiť"
    name="add-price"
    full-height
    scrollable
    size="md"
    type="from-right"
    @hidden="Object.assign($data, $options.data())"
    @ok="savePrice"
    @show="fetchData"
  >
    <b-overlay :blur="null" :show="loading" class="h-100" opacity="0">
      <transition mode="out-in" name="fadeShort">
        <div v-if="!loading" ref="scroll" v-bar>
          <div>
            <h4 v-if="title" class="mb-3">
              {{ title }}
            </h4>
            <b-form-group v-if="!title" label="Položka" label-for="price_id">
              <b-form-select
                v-model="form.price_id"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('price_id') }"
                :select-size="1"
                name="price_id"
                data-vv-as="Položka"
              >
                <option :value="null">--Nedefinované--</option>
                <option
                  v-for="list in selection.list"
                  :key="list.id"
                  :value="list.id"
                >
                  {{ list.title }}
                </option>
              </b-form-select>
              <b-form-invalid-feedback>
                {{ errors.first('price_id') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="Hodnota" label-for="value">
              <vue-autonumeric
                v-model="form.value"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('value') }"
                :options="{
                  decimalCharacter: ',',
                  digitGroupSeparator: ' ',
                  decimalPlaces: 4,
                  emptyInputBehavior: 'null',
                }"
                class="form-control"
                data-vv-as="Hodnota"
                name="value"
              />
              <b-form-invalid-feedback>
                {{ errors.first('value') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="Jednotka" label-for="unit">
              <b-form-input
                v-model="form.unit"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('unit') }"
                data-vv-as="Jednotka"
                name="unit"
              />
              <b-form-invalid-feedback>
                {{ errors.first('unit') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="Platné od" label-for="validFrom">
              <single-date
                v-model="form.validFrom"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('validFrom') }"
                data-vv-as="Platné od"
                name="validFrom"
              />
              <b-form-invalid-feedback>
                {{ errors.first('validFrom') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
        </div>
      </transition>
    </b-overlay>
  </modal>
</template>
<script>
import Modal from '@/components/Modal'
import SingleDate from '@/components/inputs/SingleDate'
export default {
  components: {
    Modal,
    SingleDate,
  },
  data() {
    return {
      loading: false,
      edit: false,
      title: null,
      selection: {
        list: [],
      },
      form: {},
    }
  },
  methods: {
    fetchData() {
      this.loading = true
      this.axios
        .all([
          this.$api.get('pricelist/get_price_list'),
          this.edit ? this.$api.get(`pricelist/${this.form.id}`) : null,
        ])
        .then(
          this.axios.spread((list, formdata) => {
            this.selection.list = list.data
            if (formdata) {
              this.form = formdata.data
            }
            this.loading = false
          }),
        )
    },
    savePrice(e) {
      e.preventDefault()
      this.$validator.validateAll().then(() => {
        if (!this.errors.any() && !this.loading) {
          this.$api
            .post(this.edit ? 'pricelist/edit' : 'pricelist/add', this.form)
            .then((res) => {
              this.$swal({
                type: 'success',
                position: 'top',
                showCloseButton: true,
                text: res.data.success,
                timer: 5000,
              })
              this.$root.$emit('modal-hide', 'add-price')
              this.$root.$emit('reloadPriceList')
            })
        } else {
          this.$swal({
            type: 'warning',
            position: 'top',
            showCloseButton: true,
            text: 'Formulár nieje správne vyplnený',
            timer: 5000,
          })
        }
      })
    },
  },
}
</script>
